import { ReactNode } from 'react';
import { FlatList } from 'react-native';

import { SizedBox } from '@/components/SizedBox';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { EventsTray, ItemSeparator, styles } from '@/feature/league-hub-sbk/components/EventsTray';
import { useEvents } from '@/feature/league-hub-sbk/hooks/use-events';
import { useLeague } from '@/feature/league-hub-sbk/hooks/use-league';
import { EventCardSkeleton } from '@/feature/lobby/components/Skeletons/EventCardSkeleton';
import { showScrollIndicator } from '@/utils/constants-platform-specific';

const EventCardSkeletonList = ({ eventCount }: { eventCount: number }) => {
    return (
        <FlatList
            data={Array.from({ length: eventCount })}
            renderItem={() => <EventCardSkeleton />}
            ItemSeparatorComponent={ItemSeparator}
            horizontal
            style={styles.flatList}
            ListHeaderComponent={<SizedBox value={16} />}
            ListFooterComponent={<SizedBox value={16} />}
            showsHorizontalScrollIndicator={showScrollIndicator}
        />
    );
};

type LobbyEventsTrayProps = {
    leagueId: string;
    header?: ReactNode;
};

export const LobbyEventsTray = ({ leagueId, header }: LobbyEventsTrayProps) => {
    const { data: events, isLoading } = useEvents({ leagueId });
    const { data: league } = useLeague(leagueId);
    const eventCount = Math.min(league?.event_count ?? 5, 5);

    if (!isLoading && !events?.length) {
        return null;
    }

    return (
        <Box pt="s20" pb="s32" backgroundColor={ds.colorToken.background.neutral.base}>
            {header}
            {isLoading ? <EventCardSkeletonList eventCount={eventCount} /> : <EventsTray events={events ?? []} />}
        </Box>
    );
};
